import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=1d8f3505&scoped=true"
import script from "./product-list.vue?vue&type=script&lang=ts"
export * from "./product-list.vue?vue&type=script&lang=ts"
import style0 from "./product-list.vue?vue&type=style&index=0&id=1d8f3505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f3505",
  null
  
)

export default component.exports